import React from 'react';
import MainLayout from '../components/layout/MainLayout';
import TimeUtilization from '../components/analytics/TimeUtilization';
import PatientFlow from '../components/analytics/PatientFlow';
import ClinicalActivity from '../components/analytics/ClinicalActivity';
import ResourceUtilization from '../components/analytics/ResourceUtilization';
import Benchmarking from '../components/analytics/Benchmarking';
import InsightsPanel from '../components/analytics/InsightsPanel';

const PracticeAnalytics = () => {
  return (
    <MainLayout 
      activeNavItem="analytics"
      searchPlaceholder="Practice Metrics"
      notifications={3}
    >
      <div className="flex h-full">
        <div className="flex-1 p-6 overflow-auto">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-2xl font-bold">Practice Analytics</h2>
            <button className="px-4 py-2 bg-blue-500 text-white rounded">
              Export
            </button>
          </div>
          
          <div className="grid grid-cols-2 gap-4 mb-4">
            <TimeUtilization />
            <PatientFlow />
          </div>
          
          <div className="grid grid-cols-2 gap-4 mb-4">
            <ClinicalActivity />
            <ResourceUtilization />
          </div>
          
          <Benchmarking />
        </div>
        <div className="w-80">
          <InsightsPanel />
        </div>
      </div>
      <div className="bg-gray-200 text-gray-600 text-sm p-2 border-t border-gray-300">
        Time period: Last 30 days | Comparison: Similar-sized oncology practices
      </div>
    </MainLayout>
  );
};

export default PracticeAnalytics;